import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AuthService } from '@app/services/auth.service';
import { HistoryBookingDetail } from '@user-history/entities/history-booking-detail';
import { abandonedReservationApi } from '@abandoned-reservation/api/abandoned-reservation.api';
import { ReservationCancellationSuccessType } from '@abandoned-reservation/entities/cancelation-reservation';

@Injectable({
  providedIn: 'root'
})
export class AbandonedReservationService {

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  public fetchUserAbandonedReservation(): Observable<HistoryBookingDetail> {
    return this.http.get<HistoryBookingDetail>(abandonedReservationApi.retarget.get_retarget);
  }

  public cancelReservation(itineraryId: string, userToken: string): Observable<ReservationCancellationSuccessType> {
    const payload = {
      itineraryId: itineraryId,
      nssUserSessionToken: userToken
    };
    const headers = this.getHeaders();
    return this.http.post<(ReservationCancellationSuccessType)>(abandonedReservationApi.cancel, payload, { headers });
  }
  
  private getHeaders(ignoreLoadingBar: boolean = true, applicationID: string = null): HttpHeaders {
    const params = {};
    if (applicationID) {
      params['X_Application_ID'] = applicationID;
    }
    if (ignoreLoadingBar) {
      params['ignoreLoadingBar'] = '';
    }
    return new HttpHeaders(params);
  }
}
